Matter = require './Matter'
module.exports = class Site extends Matter
  piece: {}
  open: ->
    $('body').append(@piece.elmt)
  
